import React, { ReactElement } from "react";

import { FieldValues, FormProvider, UseFormReset, useForm } from "react-hook-form";

import styles from "./Form.module.scss";

const Form = ({
  children,
  onSubmit,
}: {
  children: ReactElement[];
  onSubmit: (data: FieldValues, reset: UseFormReset<FieldValues>) => void;
}) => {
  const methods = useForm({
    mode: "onTouched",
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit((formData) => {
          onSubmit(formData, methods.reset);
        })}
        className={styles["form-section"]}
      >
        {React.Children.map(children, (child) => React.cloneElement(child))}
      </form>
    </FormProvider>
  );
};

export default Form;
